export type Selection = { planId: string; from: string; to: string };
export type View = "overview" | "plan" | "actual" | "cost";
export const endpoint = "/api/production/reports/production-workspace";
export const query = (selection: Selection) => new URLSearchParams({ ...(selection.planId ? {planId: selection.planId} : {}), from: selection.from, to: selection.to }).toString();
export const sameSelection = (left: Selection, right: Selection) => query(left) === query(right);
